

var tree_editorStyle = (function() {
  var stroke = 'rgba(200,200,200,1)';
  var fill = 'rgba(0,0,255,0.5)';

  return {
    style: new ol.style.Style({
      fill: new ol.style.Fill({ color: fill }),
      stroke: new ol.style.Stroke({ color: stroke, width: 4 })
    }),

    legend: {
      type: 'Rect',
      elements: [{
        label: "tree_editor", //same as layer key
        stroke: stroke,
        fill: fill,
        strokeWidth: 2
      }]
    }
  };

})();



//**********************************************************************************************
// Isolated Tree (IT) Styles -------------------
//**********************************************************************************************

// Helpers //
const rgba = function(red, green, blue, alpha, isSelected) {
  if (isSelected) {
    red = (red == 0) ? IT_LIGHTER_COLOR : red;
    green = (green == 0) ? IT_LIGHTER_COLOR : green;
    blue = (blue == 0) ? IT_LIGHTER_COLOR : blue;
  }
  return "rgba(" + red + "," + green + ","  + blue + ","  + alpha + ")";
};

// Common attributes //
const IT_STYLE_WIDTH = 6;
const IT_STYLE_RADIUS = 4;
const IT_LEGEND_WIDTH = 8;
const IT_LIGHTER_COLOR = 150;

// Colors //
const IT_COLOR_ALPHA = 1;
const IT_COLOR_BLUE = (isSel) => { return rgba(0,0,255,IT_COLOR_ALPHA,isSel) };
const IT_COLOR_RED = (isSel) => { return rgba(255,0,0,IT_COLOR_ALPHA,isSel) };
const IT_COLOR_GREEN = (isSel) => { return rgba(0,255,0,IT_COLOR_ALPHA,isSel) };
const IT_COLOR_YELLOW = (isSel) => { return rgba(255,255,0,IT_COLOR_ALPHA,isSel) };
const IT_COLOR_ORANGE = (isSel) => { return rgba(255,140,0,IT_COLOR_ALPHA,isSel) };
const IT_COLOR_VIOLET = (isSel) => { return rgba(138,43,226,IT_COLOR_ALPHA,isSel) };
const IT_COLOR_BLACK = (isSel) => { return rgba(0,0,0,IT_COLOR_ALPHA,isSel) };

// Style and Legend Abstractions //
const getOpenlayerStyle = function(style, resolution, feature) {
  if(resolution < 5) {
    return [new ol.style.Style({
      image: new ol.style.Circle({
        radius: IT_STYLE_RADIUS,
        fill: new ol.style.Fill({ color: style.fill }),
        stroke: new ol.style.Stroke({ color: style.stroke, width: IT_STYLE_WIDTH })
      })
      , text : textStyle(feature)
    })];
  }
  else {
    return [new ol.style.Style({
      image: new ol.style.Circle({
        radius: IT_STYLE_RADIUS,
        fill: new ol.style.Fill({ color: style.fill }),
        stroke: new ol.style.Stroke({ color: style.stroke, width: IT_STYLE_WIDTH })
      })
    })];
  }
};

const isolatedTreeStyle = function(getStyle, resolution, getType, feature, attribute, isSelected = false) {
  var value = undefined;
  if (feature.wpimodel) {
    value = feature.wpimodel[attribute];
  }
  var style = getStyle(getType(value), isSelected);
  return getOpenlayerStyle(style, resolution, feature);
};

const isolatedTreeLegend = function (getStyle, types) {
  var symbData = { type: 'Line', elements: [] };
  for(var i = 0; i < types.length; i++) {
    var style = getStyle(types[i], false);
    symbData.elements.push({
      label: types[i],
      stroke: style.stroke,
      fill: style.fill,
      strokeWidth: IT_LEGEND_WIDTH
    });
  }
  return symbData;
};

const textStyle = function (feature) {
  let text = "";
  if (feature.wpimodel) {
    text = feature.wpimodel.id.toString() + " - " + feature.wpimodel.variety.latin_name;
  }
  return new ol.style.Text({
      textAlign: "center",
      textBaseline: "bottom",
      font: "normal" + " " + "12px" + " " + "Arial", // weight size font
      text: text,
      //fill: new ol.style.Fill({color: "#000000"}),
      stroke: new ol.style.Stroke({color: "#ffffff", width: 3}),
      offsetX: 0,
      offsetY: 20,
      placement: "point",
      maxAngle: 0,
      overflow: undefined,
      rotation: 0.0
  });
};


var isolatedTreeStyleScore = (function() {
  var stroke = 'rgba(0,0,0,1)';
  var fill = 'rgba(255,220,220,0.5)';
  return {
    style: function(feature, resolution) {
      if (feature.wpimodel) {
        var totalScore = feature.wpimodel["total_score"];
        return new ol.style.Style({
          image: new ol.style.Circle({
            radius: Math.max(1, 1+(totalScore/5)),
            fill: new ol.style.Fill({ color: fill }),
            stroke: new ol.style.Stroke({ color: stroke, width: 0 })
          }),
        });
      }
    },
    legend: {
      type: 'Circle',
      elements: [
        { label: "5", radius: 2, stroke: stroke, fill: fill, strokeWidth: 1},
        { label: "10", radius: 3, stroke: stroke, fill: fill, strokeWidth: 1},
        { label: "15", radius: 4, stroke: stroke, fill: fill, strokeWidth: 1},
        { label: "20", radius: 5, stroke: stroke, fill: fill, strokeWidth: 1},
        { label: "25", radius: 6, stroke: stroke, fill: fill, strokeWidth: 1},
        { label: "30", radius: 7, stroke: stroke, fill: fill, strokeWidth: 1},
        { label: "35", radius: 8, stroke: stroke, fill: fill, strokeWidth: 1},
        { label: "40", radius: 9, stroke: stroke, fill: fill, strokeWidth: 1},
        ]
    }
  };
})();

var isolatedTreeStyleEligibility = (function() {
  
  const notEligibleNotProposedType = "map_isolatedTree_not_eligible_not_proposed";
  const notEligibleProposedType = "map_isolatedTree_not_eligible_proposed";
  const eligibleNotProposedType = "map_isolatedTree_eligible_not_proposed";
  const eligibleProposedType = "map_isolatedTree_eligible_proposed";
  const isRankedType = "map_isolatedTree_score_isRanked";
  
  /* Types */
  const types =
    [ isRankedType,
      eligibleProposedType,
      eligibleNotProposedType,
      notEligibleProposedType,
      notEligibleNotProposedType
    ]
    
  /* Styles */
  const styleNotEligibleNotProposed = (isSel) => {
    return { stroke: IT_COLOR_BLUE(isSel), fill: IT_COLOR_BLUE(isSel) };
  };

  const styleNotEligibleProposed = (isSel) => {
    return { stroke: IT_COLOR_VIOLET(isSel), fill: IT_COLOR_VIOLET(isSel) };
  };
  
  const styleEligibleNotProposed = (isSel) => {
    return { stroke: IT_COLOR_RED(isSel), fill: IT_COLOR_RED(isSel) };
  };
  
  const styleEligibleProposed = (isSel) => {
    return { stroke: IT_COLOR_ORANGE(isSel), fill: IT_COLOR_ORANGE(isSel) };
  };
  
  const styleIsRanked = (isSel) => {
    return { stroke: IT_COLOR_GREEN(isSel), fill: IT_COLOR_GREEN(isSel) };
  };
  
  /* Logic */
  const getType = function(feature) {
    let type = undefined;
    let totalScore, isCandidate, isRanked;
    
    if (feature.wpimodel) {
      totalScore = feature.wpimodel["total_score"];
      isCandidate = feature.wpimodel["is_candidate"];
      isRanked = feature.wpimodel["is_ranked"];
    }
    
    if (isRanked) {
      type = isRankedType
    } else {
      if (totalScore > 15) {
        if (isCandidate) {
          type = eligibleProposedType;
        } else {
          type = eligibleNotProposedType;
        }
      } else {
        if (isCandidate) {
          type = notEligibleProposedType;
        } else {
          type = notEligibleNotProposedType;
        }
      }
    }
    
    return type;
  };
  
  /* Style */
  const getStyle = function(type, isSelected=false) {
    let style = undefined;
    switch (type) {
      case notEligibleNotProposedType:
        style = styleNotEligibleNotProposed(isSelected);
      break;
      
      case notEligibleProposedType:
        style = styleNotEligibleProposed(isSelected);
      break;
      
      case eligibleNotProposedType:
        style = styleEligibleNotProposed(isSelected);
      break;
      
      case eligibleProposedType:
        style = styleEligibleProposed(isSelected);
      break;
      
      case isRankedType:
        style = styleIsRanked(isSelected);
      break;
    }
    return style;
  };

  return {
    selectStyle: function(feature, resolution) {
      const style = getStyle(getType(feature), true);
      return getOpenlayerStyle(style, resolution, feature);
    },
    style: function(feature, resolution) {
      const style = getStyle(getType(feature));
      return getOpenlayerStyle(style, resolution, feature);
    },
    legend: (function() {
      return isolatedTreeLegend(getStyle, types);
    })()
  };
})();

var isolatedTreeStyleIsRanked = (function() {
  /* Types */
  const isRanked = "is_ranked";
  const isCandidate = "is_candidate";


  const typeRankedCandidate = "map_isolatedTree_isRanked_candidate";
  const typeRankedTrue = "map_isolatedTree_isRanked_true";
  const typeRankedFalse = "map_isolatedTree_isRanked_false";
  const typeRankedNomore = "map_isolatedTree_isRanked_nomore";
  
  const types =
    [ typeRankedCandidate,
      typeRankedTrue,
      typeRankedFalse,
      typeRankedNomore
    ]

  /* Styles */
  const styleRankedCandidate = (isSel) => {
    return { stroke: IT_COLOR_RED(isSel), fill: IT_COLOR_RED(isSel) };
  };
  const styleRankedTrue = (isSel) => {
    return { stroke: IT_COLOR_GREEN(isSel), fill: IT_COLOR_GREEN(isSel) };
  };

  const styleRankedFalse = (isSel) => {
    return { stroke: IT_COLOR_BLUE(isSel), fill: IT_COLOR_BLUE(isSel) };
  };
    
  const styleRankedNomore = (isSel) => {
    return { stroke: IT_COLOR_BLACK(isSel), fill: IT_COLOR_BLACK(isSel) };
  };

  /* Logic */
  const getType = function(isRanked, isCandidate) {
    if (isRanked)
      return typeRankedTrue;
    else
      if (isCandidate)
        return typeRankedCandidate
      else
        return typeRankedFalse;
  };

  const getStyle = function(type, isSelected) {
    var style = undefined;
    switch(type) {
      case typeRankedCandidate:
        style = styleRankedCandidate(isSelected);
      break;

      case typeRankedTrue:
        style = styleRankedTrue(isSelected);
      break;

      case typeRankedFalse:
        style = styleRankedFalse(isSelected);
      break;

      case typeRankedNomore:
        style = styleRankedNomore(isSelected);
      break;
    }
    return style;
  };

  return {
    selectStyle: function(feature, resolution) {
      return isolatedTreeStyle(getStyle, resolution, getType, feature, isRanked, isCandidate, true);
    },
    style: function(feature, resolution) {
      return isolatedTreeStyle(getStyle, resolution, getType, feature, isRanked, isCandidate);
    },
    legend: (function() {
      return isolatedTreeLegend(getStyle, types);
    })()
  };
})();

var isolatedTreeStyleCircumference = (function() {

  /* Business */
  const federalThreshold = 100;
  const cantonalThreshold = 50;
  const startThreshold = 20;

  /* Types */
  const attribute = "circumference";

  const typeFederal = "map_isolatedTree_circumference_federal";
  const typeCantonal = "map_isolatedTree_circumference_cantonal";
  const typeStart = "map_isolatedTree_circumference_start";
  const typeDoesntComply = "map_isolatedTree_circumference_doesnt_comply";

  const types =
    [ typeFederal,
      typeCantonal,
      typeStart,
      typeDoesntComply
    ];

  /* Styles */
  const styleFederal = (isSel) => {
    return { stroke: IT_COLOR_GREEN(isSel), fill: IT_COLOR_GREEN(isSel) };
  };

  const styleCantonal = (isSel) => {
    return { stroke: IT_COLOR_BLUE(isSel), fill: IT_COLOR_BLUE(isSel) };
  };

  const styleStart = (isSel) => {
    return { stroke: IT_COLOR_YELLOW(isSel), fill: IT_COLOR_YELLOW(isSel) };
  };

  const styleDoesntComply = (isSel) => {
    return { stroke: IT_COLOR_RED(isSel), fill: IT_COLOR_RED(isSel) };
  };

  /* Logic */
  const getType = function(circumference) {
    if (circumference > federalThreshold)
      return typeFederal;
    else if (circumference > cantonalThreshold)
      return typeCantonal;
    else if (circumference > startThreshold)
      return typeStart;
    else
      return typeDoesntComply;
  };

  const getStyle = function(type, isSel) {
    var style = undefined;
    switch(type) {
      case typeFederal:
        style = styleFederal(isSel);
      break;
      case typeCantonal:
        style = styleCantonal(isSel);
      break;
      case typeStart:
        style = styleStart(isSel);
      break;
      case typeDoesntComply:
        style = styleDoesntComply(isSel);
      break;
    }
    return style;
  };

  return {
    selectStyle: function(feature, resolution) {
      return isolatedTreeStyle(getStyle, resolution, getType, feature, attribute, true);
    },
    style: function(feature, resolution) {
      return isolatedTreeStyle(getStyle, resolution, getType, feature, attribute);
    },
    legend: (function() {
      return isolatedTreeLegend(getStyle, types);
    })()
  };
})();

var isolatedTreeStyleHasSHInterest = (function() {

  /* Types */
  const attribute = "hasSocioHistoricalInterest";

  const typeTrue = "map_isolatedTree_has_sh_interest_true";
  const typeFalse = "map_isolatedTree_has_sh_interest_false";

  const types =
    [ typeTrue,
      typeFalse
    ];

  /* Styles */
  const styleTrue = (isSel) => {
    return { stroke: IT_COLOR_RED(isSel), fill: IT_COLOR_RED(isSel) };
  };

  const styleFalse = (isSel) => {
    return { stroke: IT_COLOR_BLUE(isSel), fill: IT_COLOR_BLUE(isSel) };
  };

  /* Logic */
  const getType = function(hasSHInterest) {
    if (hasSHInterest)
      return typeTrue;
    return typeFalse;
  };

  const getStyle = function(type, isSel) {
    var style = undefined;
    switch(type) {
      case typeTrue:
        style = styleTrue(isSel);
      break;
      case typeFalse:
        style = styleFalse(isSel);
      break;
    }
    return style;
  };

  return {
    selectStyle: function(feature, resolution) {
      return isolatedTreeStyle(getStyle, resolution, getType, feature, attribute, true);
    },
    style: function(feature, resolution) {
      return isolatedTreeStyle(getStyle, resolution, getType, feature, attribute);
    },
    legend: (function() {
      return isolatedTreeLegend(getStyle, types);
    })()
  };
})();




var treePositionStyle = (function() {
  var stroke = 'rgba(53,130,15,1)';
  var fill = 'rgba(53,130,15,0.5)';
  return {
    style: function(feature, resolution) {
      return new ol.style.Style({
        image: new ol.style.Circle({
          radius: 3,
          fill: new ol.style.Fill({ color: fill }),
          stroke: new ol.style.Stroke({ color: stroke, width: 0 })
        })
      });
    },

    legend: {
      type: 'Circle',
      elements: [{
        label: "Arbres isolés (TLM3D)",
        radius: 8,
        stroke: stroke,
        fill: fill,
        strokeWidth: 1
      }]
    }
  };
})();


var treeHeightStyle = (function() {
  var getStyle = function(level) {
    var stroke = 'rgba(254,254,254,1)';
    var width = 0;
    switch (true) {
      case (level>30):
        fill = 'rgba(230,24,26,1)';
        radius = 6
        break;
      case (level>20):
        fill = 'rgba(251,128,3,1)';
        radius = 5
        break;
      case (level>6):
        fill = 'rgba(53,160,42,1)';
        radius = 4
        break;
      case (level>3):
        fill = 'rgba(53,160,42,1)';
        radius = 3
        break;
      default:
        fill = 'rgba(53,160,42,1)';
        radius = 2
        break;
    }
    return { stroke:stroke, fill:fill, width:width, radius:radius };
  };

  return {
    style: function(feature, resolution) {
      var level = feature.getProperties().rast_val;
      var params;
      if(level) {
        params = getStyle(level);
      }
      else
      {
        var stroke = 'rgba(24,185,63,0)';
        var width = 0;
        var fill = 'rgba(186,186,186,0.6)';
        var radius = 3
        params = { stroke:stroke, fill:fill, width:width, radius:radius }
      }
      return [new ol.style.Style({
        image: new ol.style.Circle({
          radius: params.radius,
          fill: new ol.style.Fill({ color: params.fill }),
          stroke: new ol.style.Stroke({ color: params.stroke, width: 0 })
        })
      })];
    },

    legend: (function() {
      var symbData = { type: 'Circle', elements: [] };
      var levels = [31,21, 10, 4, 1];
      var labels = ['30-60m','20-30m','6-20m','3-6m','0-3m'];
      for(var i = 0; i < levels.length; i++) {
        var params = getStyle(levels[i]);
        symbData.elements.push({
          label: labels[i],
          stroke: params.stroke,
          fill: params.fill,
          strokeWidth: 0,
          radius: params.radius
        });
      }
      return symbData;
    })()

  };
})();


var svsTreeStyle = (function() {
  var stroke = 'rgba(0,0,0,1)';
  var fill = 'rgba(220,220,220,0.1)';
  return {
    style: function(feature, resolution) {
      if (feature.wpimodel) {
        var value = feature.wpimodel['Numéro'];
        return new ol.style.Style({
          image: new ol.style.Circle({
            radius: 3,
            fill: new ol.style.Fill({ color: fill }),
            stroke: new ol.style.Stroke({ color: stroke, width: 0 })
          }),
          text: new ol.style.Text({
            text: value,
            font: 'sans-serif',
            fill: new ol.style.Fill({
                color: 'rgba(0,0,0,1)'
            }),
            stroke: new ol.style.Stroke({
              color: '#fff',
              width: 3
            }),
            padding : [10,10,10,10],
            scale : 1.4
          })
        });
      }
    },

    legend: {
      type: 'Circle',
      elements: [{
        label: "Arbre SVS",
        radius: 8,
        stroke: stroke,
        fill: fill,
        strokeWidth: 1
      }]
    }
  };
})();



var isolatedTreeStyleIsConsult = (function() {
  var idArray = 
    [ 49
    , 50
    , 52
    , 53
    , 120
    , 121
    , 122
    , 123
    , 124
    , 125
    , 126
    , 127
    , 128
    , 129
    , 190
    , 193
    , 231
    , 232
    , 233
    , 234
    , 235
    , 237
    , 238
    , 239
    , 242
    , 251
    , 252
    , 253
    , 255
    , 256
    , 259
    , 260
    , 394
    , 396
    , 397
    , 398
    , 399
    , 429
    , 537
    , 538
    , 539
    , 540
    , 541
    , 544
    , 546
    , 547
    , 548
    , 550
    , 551
    , 569
    , 571
    , 572
    , 580
    , 583
    , 584
    , 585
    , 587
    , 588
    , 589
    , 592
    , 597
    , 604
    , 609
    , 611
    , 623
    , 637
    , 648
    , 649
    , 650
    , 659
    , 664
    , 666
    , 675
    , 676
    , 677
    , 678
    , 679
    , 680
    , 681
    , 682
    , 683
    , 688
    , 689
    , 696
    , 699
    , 700
    , 701
    , 702
    , 745
    , 747
    , 750
    , 781
    , 789
    , 803
    , 806
    , 807
    , 821
    , 845
    , 936
    , 954
    , 957
    , 958
    , 965
    , 969
    , 970
    , 971
    , 973
    , 976
    , 977
    , 985
    , 987
    , 988
    , 990
    , 992
    , 994
    , 997
    , 1002
    , 1003
    , 1012
    , 1015
    , 1016
    , 1017
    , 1019
    , 1021
    , 1023
    , 1025
    , 1027
    , 1028
    , 1029
    , 1030
    , 1031
    , 1032
    , 1033
    , 1040
    , 1041
    , 1042
    , 1048
    , 1055
    , 1058
    , 1059
    , 1060
    , 1063
    , 1065
    , 1066
    , 1068
    , 1069
    , 1071
    , 1073
    , 1075
    , 1079
    , 1083
    , 1084
    , 1086
    , 1094
    , 1095
    , 1098
    , 1100
    , 1101
    , 1102
    , 1103
    , 1104
    , 1109
    , 1110
    , 1111
    , 1112
    , 1114
    , 1116
    , 1120
    , 1121
    , 1136
    , 1140
    , 1202
    , 1263
    , 1266
    , 1268
    , 1269
    , 1270
    , 1271
    , 1273
    , 1282
    , 1334
    , 1346
    , 1348
    , 1349
    , 1350
    , 1353
    , 1367
    , 1369
    , 1370
    , 1371
    , 1372
    , 1373
    , 1378
    , 1379
    , 1380
    , 1382
    , 1384
    , 1385
    , 1386
    , 1387
    , 1398
    , 1399
    , 1400
    , 1402
    , 1405
    , 1406
    , 1407
    , 1408
    , 1409
    , 1413
    , 1414
    , 1416
    , 1421
    , 1422
    , 1423
    , 1424
    , 1425
    , 1426
    , 1427
    , 1429
    , 1438
    , 1440
    , 1441
    , 1446
    , 1447
    , 1448
    , 1450
    , 1452
    , 1459
    , 1467
    , 1471
    , 1473
    , 1474
    , 1475
    , 1476
    , 1480
    , 1482
    , 1483
    , 1484
    , 1488
    , 1489
    , 1490
    , 1492
    , 1493
    , 1506
    , 1507
    , 1508
    , 1511
    , 1514
    , 1515
    , 1515
    , 1529
    , 1532
    , 1533
    , 1535
    , 1536
    , 1538
    , 1544
    , 1552
    , 1556
    , 1557
    , 1558
    , 1559
    , 1560
    , 1561
    , 1562
    , 1563
    , 1564
    , 1565
    , 1566
    , 1567
    , 1568
    , 1569
    , 1572
    , 1573
    , 1582
    , 1583
    , 1584
    , 1585
    , 1586
    , 1590
    , 1593
    , 1595
    , 1596
    , 1618
    , 1619
    , 1622
    , 1623
    , 1624
    , 1625
    , 1633
    , 1634
    , 1636
    , 1637
    , 1639
    , 1640
    , 1641
    , 1643
    , 1644
    , 1647
    , 1655
    , 1659
    , 1660
    , 1662
    , 1664
    , 1665
    , 1666
    , 1670
    , 1671
    , 1672
    , 1673
    , 1674
    , 1675
    , 1676
    , 1690
    , 1691
    , 1692
    , 1693
    , 1696
    , 1697
    , 1698
    , 1701
    , 1702
    , 1703
    , 1707
    , 1709
    , 1712
    , 1714
    , 1715
    , 1719
    , 1796
    , 1797
    , 1806
    , 1809
    , 1810
    , 1813
    , 1814
    , 1815
    , 1844
    , 1846
    , 1851
    , 1855
    , 1856
    , 1857
    , 1858
    , 1860
    , 1862
    , 1865
    , 2082
    , 2306
    , 2307
    , 2308
    , 2309
    , 2310
    , 2312
    , 2319
    , 2322
    , 2324
    , 2333
    , 2334
    , 2337
    , 2338
    , 2344
    , 2349
    , 2357
    , 2361
    , 2366
    , 2370
    , 2371
    , 2373
    , 2375
    , 2376
    , 2377
    , 2378
    , 2380
    , 2384
    , 2660
    , 2666
    , 2667
    , 2670
    , 2674
    , 2682
    , 2686
    , 2891
    , 2901
    , 2903
    , 2905
    , 2909
    , 3029
    , 3034
    , 3035
    , 3039
    , 3041
    , 3104
    , 3107
    , 3108
    , 3109
    , 3112
    , 3113
    , 3116
    , 3119
    , 3342
    , 3348
    , 3349
    , 3358
    , 3361
    , 3363
    , 3452
    , 3455
    , 3456
    , 3458
    , 3483
    , 3506
    , 3507
    , 3508
    , 3509
    , 3516
    , 3518
    , 3519
    , 3521
    , 3522
    , 3532
    , 3535
    , 3536
    , 3540
    , 3546
    , 3548
    , 3570
    , 3577
    , 3579
    , 3581
    , 3600
    , 3734
    , 3735
    , 3751
    , 3759
    , 3791
    , 3981
    , 4002
    , 4011
    , 4401
    , 5098
    , 5099
    , 5100
    , 5102
    , 5103
    , 5106
    , 5107
    , 5108
    , 5109
    , 5110
    , 5112
    , 5113
    , 5114
    , 5115
    , 5117
    , 5119
    , 5120
    , 5121
    , 5242
    , 5244
    , 5246
    , 5247
    , 5249
    , 5250
    , 5251
    , 5685
    , 5691
    , 5693
    , 5701
    , 5705
    , 5712
    , 5713
    , 5714
    , 5720
    , 5721
    , 5722
    , 5723
    , 5724
    , 5726
    , 5734
    , 5918
    , 5919
    , 5920
    , 5922
    , 5931
    , 5932
    , 5937
    , 5982
    , 5983
    , 5984
    , 5985
    , 5988
    , 5993
    , 6122
    , 6123
    , 6124
    , 6125
    , 6126
    , 6213
    , 7592
    , 7593
    , 7594
    , 7595
    , 7596
    , 7598
    , 7604
    , 7606
    , 7747
    , 7748
    , 7750
    , 7751
    , 7752
    , 7753
    , 7754
    , 7755
    , 7758
    , 7761
    , 7762
    ];

  var getIdStyle = function(isSel) {
    var width = 0;
    var stroke = 'rgba(0,0,0,1)';
    var fill = 'rgba(200,230,0,0.5)';
    if (isSel) {
      var fill = 'rgba(210,0,0,0.5)';
    }
    return { stroke:stroke, fill:fill, width: width };
  };

  return {
    style: function(feature, resolution) {
      if (feature.wpimodel) {
        var id = feature.wpimodel["id"];
        var isSel = idArray.includes(id);
        var colors = getIdStyle(isSel);
        if (resolution < 5) {
          return new ol.style.Style({
            image: new ol.style.Circle({
              radius: 6,
              fill: new ol.style.Fill({ color: colors.fill }),
              stroke: new ol.style.Stroke({ color: colors.stroke, width: colors.width })
            }),
            text : textStyle(feature)
          });
        }
        else {
          return new ol.style.Style({
            image: new ol.style.Circle({
              radius: 6,
              fill: new ol.style.Fill({ color: colors.fill }),
              stroke: new ol.style.Stroke({ color: colors.stroke, width: colors.width })
            }),
          });
        }
      }
    },
    legend: (function() {
      var symbData = { type: 'Circle', elements: [] };
      var cc = [true, false];
      var ccLabels = [ 'map_isolatedTree_isConsult_true', 'map_isolatedTree_isConsult_false'];
      for(var i = 0; i < cc.length; i++) {
        var colors = getIdStyle(cc[i]);
        symbData.elements.push({
          label: ccLabels[i],
          fill: colors.fill,
          stroke: colors.stroke,
          strokeWidth: colors.width,
          radius: 8
        });
      }
      return symbData;
    })()

  };
})();

